/**
 * Vue 3 compatibility mixin for vue3-treeselect
 *
 * vue3-treeselect v0.1.10 has compatibility issues with Vue 3's render function API.
 * This mixin provides the missing $createElement function that maps to Vue 3's h function.
 */

import { getCurrentInstance, h } from 'vue';

// Enhanced createElement function with debugging
const createElementWrapper = (...args) => {
    if (import.meta.env.MODE === 'development') {
        // Only log in development to avoid production noise
        if (args[0] && typeof args[0] === 'string' && args[0].includes('vue-treeselect')) {
        }
    }
    return h(...args);
};

export default {
    beforeCreate() {
        // Provide $createElement for Vue 2 compatibility
        // This is needed for vue3-treeselect which still uses the old render function API
        if (!this.$createElement) {
            this.$createElement = createElementWrapper;
        }
    },

    created() {
        // Ensure $createElement is available after component creation
        if (!this.$createElement) {
            this.$createElement = createElementWrapper;
        }
    },

    beforeMount() {
        // Additional safety check before mounting
        const instance = getCurrentInstance();
        if (instance && !instance.proxy?.$createElement) {
            instance.proxy.$createElement = createElementWrapper;
        }
    },

    setup() {
        // Alternative approach for composition API components
        const instance = getCurrentInstance();

        if (instance && !instance.proxy?.$createElement) {
            instance.proxy.$createElement = createElementWrapper;
        }

        return {
            $createElement: createElementWrapper,
        };
    },
};
